import React from "react";
import HeadOfficeCashManagement from "../../features/headofficecashmanagement";
import withProviders from "../../hooks/withProviders";
import { FilterProvider, FeeManagementDefaultFilters } from "../../hooks/FilterContext";

const CashManagementPage = () => <HeadOfficeCashManagement />

export default withProviders([FilterProvider, { defaultFilters: FeeManagementDefaultFilters, filterStore: 'admin.management.cash' }])(CashManagementPage);